module.exports = __webpack_public_path__ + "static/img/telegram.16476286.png";